"use client";
import React from "react";
import { ReviewItem } from "./ReviewItem";

export const ReviewList = ({ reviews, selectedTag, searchTerm }) => {
 
  // If no reviews match the filters
  if (Object.keys(reviews).length === 0) {
    return (
      <div className="text-center py-8 bg-gray-50 rounded-lg">
        <p className="text-gray-500">
          No reviews found matching your criteria.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {reviews && reviews.map((review) => (
        <ReviewItem key={review.id} review={review} />
      ))}
    </div>
  );
};
